import React, {PureComponent} from "react";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import GameItem from "./GameItem";
import {GameEntity} from "../data/entities/GameEntity";
import {FormattedMessage} from "react-intl";
import classNames from 'classnames';
import {AdobeAnalyticsContext} from "../context/AdobeAnalyticsContext";

interface Props {
    games: GameEntity[];
    handleGameAction: Function;
    itemsPerPage?: number
    userOwnership: Function;
}

interface State {
    visibleGames: number;
}

export default class GamesList extends PureComponent<Props, State> {
    static contextType = AdobeAnalyticsContext;
    context!: React.ContextType<typeof AdobeAnalyticsContext>;

    private itemsPerPage: number = this.props.itemsPerPage ? this.props.itemsPerPage : 21;
    private canHover: boolean = !matchMedia('(hover: none)').matches;

    state: State = {
        visibleGames: this.itemsPerPage
    };

    render(): JSX.Element {
        const gameGridClasses = classNames({
            'game-grid': true,
            'can-hover': this.canHover
        });

        return (
            <React.Fragment>
                {
                    this.props.games.length > 0 &&
                        <TransitionGroup className={gameGridClasses}>
                            {
                                this.props.games.slice(0, this.state.visibleGames).map((game, index) => {
                                    return (
                                        <CSSTransition
                                            key={game.id + "-" + game.packageId}
                                            timeout={500}
                                            classNames="move"
                                        >
                                            <GameItem
                                                key={index}
                                                index={index}
                                                game={game}
                                                handleGameAction={this.props.handleGameAction}
                                                userOwnership={this.props.userOwnership}
                                            />
                                        </CSSTransition>
                                    );
                                })
                            }
                        </TransitionGroup>
                }

                {
                    (this.state.visibleGames < this.props.games.length) &&
                        <div className="loadmore">
                            <button onClick={this.loadMoreGames}>
                                <FormattedMessage id="action.load_more_games"/>
                            </button>
                        </div>
                }
            </React.Fragment>
        );
    }

    loadMoreGames = () => {
        this.context.track("clickevent", {location: "page", category: "interaction", action: "load more games"});

        this.setState({
            visibleGames: this.state.visibleGames + this.itemsPerPage
        });
    };
}